document.addEventListener('DOMContentLoaded', () => {

    const grid =
        document.querySelector('.testimonials__grid');

    const prev =
        document.querySelector('.testimonials__nav--prev');

    const next =
        document.querySelector('.testimonials__nav--next');

    if (!grid || !prev || !next) return;

    function getScrollAmount() {

        const card =
            grid.querySelector('.testimonial-card');

        if (!card) return 300;

        const gap =
            parseInt(
                getComputedStyle(grid).gap
            );

        return card.offsetWidth + gap;
    }

    prev.addEventListener('click', () => {

        grid.scrollBy({

            left: -getScrollAmount(),

            behavior: 'smooth'
        });

    });

    next.addEventListener('click', () => {

        grid.scrollBy({

            left: getScrollAmount(),

            behavior: 'smooth'
        });

    });

});